// 用户模块
export default {
    namespaced: true,
    state () {
      return {
        token:null,
        // 用户信息
        userInfo: {},
        // 项目详情
        projectDetail:{},
        // 项目成员
        projectPeople:[],
        // 获取用户成员
        UserPeople:[],
        // 标准文件名称
        fileName:[],
        // 任务计划
        planList:[],
        // 项目助理
        assistant:'',
        owner:'',
        download:null,
        edit:null,
        
        allpower:null
      }
    },
    mutations: {
        // 修改用户信息
        setUserInfo (state, payload) {
          state.userInfo = payload
        },

        // 清除用户信息
        clearUserInfo(state,payload){
          state.userInfo = payload
        },
        
        // 修改项目详情
        setProjectDetail(state, payload){
          state.projectDetail = payload
        },

        // 清除项目详情 
        clearProjectDetail(state, payload){
          state.projectDetail = payload
        },

        // 设置项目成员
        setProjectPeople(state,payload){
          state.projectPeople = payload
        },

        // 获取用户成员
        setUserPeople(state,payload){
          state.UserPeople = payload
        },
        
        // 设置标准文件名称
        setFileName(state,payload){
          state.fileName = payload
        },
        // 任务计划
        setplanList(state,payload){
          state.planList = payload
        },

        // 修改项目助理
        setassistant(state,payload){
          state.assistant = payload
        },
        setowner(state,payload){
          state.owner = payload
        }
        
        
    },
    actions:{
      // 获取用户信息
      getUserInfo(context,payload){
        context.commit('setUserInfo',payload)
      },

      // 获取项目详情
      getProjectDetail(context,payload){
        context.commit('setProjectDetail',payload)
      },
      
      // 获取项目成员 
      getProjectPeople(context,payload){
        context.commit('setProjectPeople',payload)
      },

      // 获取用户成员
      getUserPeople(context,payload){
        context.commit('setUserPeople',payload)
      },
      
      // 获取文件名称
      getFileName(context,payload){
        context.commit('setFileName',payload)
      },

      // 任务计划文件
      getplanList(context,payload){
        context.commit('setplanList',payload)
      },
      
      // 获取项目责任人
      getowner(context,payload){
        context.commit('setowner',payload)
      },
      
      // 获取项目助理
      getassistant(context,payload){
        context.commit('setassistant',payload)
      }
    },
    getters:{
      // 判断是否为会员部或者管理员 （可以查看企业列表）
      is_vip(state){
        if(state.userInfo.roles != undefined){
          return state.userInfo.roles.some(item => item == 'MembershipManagement' || item == 'MembershipDepartment' || item == 'UnderSecretaryGeneral' || item == 'Administrators')
        }else{
          return false
        }
      },

      // 判断是否为会员部成员
      is_Management(state){
        if(state.userInfo.roles != undefined){
          return state.userInfo.roles.some(item => item == 'MembershipDepartment' )
        }
      },

      // 判断是否为责任人
      is_Management(state){
        if(state.userInfo.roles != undefined){
          return state.userInfo.roles.some(item => item == 'MembershipManagement' )
        }
      },
      
      // 判断是否为秘书长
      is_General(state){
        if(state.userInfo.roles != undefined){
          return state.userInfo.roles.some(item => item == 'UnderSecretaryGeneral' )
        }
      },
    }
}